import Swiper, { A11y, Autoplay, EffectFade, Navigation, Pagination } from 'swiper'

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {

    // Slider home
    const homeSlideshow = document.querySelector('.home-slideshow .swiper-container') !== null;

    if (homeSlideshow) {
        let nbSlides = document.querySelectorAll('.home-slideshow .swiper-container .swiper-slide').length;
        let dataSlideAuto = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_auto');
        let dataSlideSpeed = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_speed');
        dataSlideSpeed = dataSlideSpeed + '000';

        Swiper.use([ A11y, Autoplay, EffectFade, Navigation, Pagination ]);
        
        let config = {
            grabCursor : 'true',
            speed: 700,
            loop : true,

            effect : 'fade',
            fadeEffect: {
                crossFade: true,
            },

            // Navigation (arrow)
            navigation: {
                nextEl: `.swiper-button-next`,
                prevEl: `.swiper-button-prev`,
            },

            // Pagination (bullet)
            pagination: {
                el: '.slideshow__pagination',
                type: 'bullets', // default
                clickable: true,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                paginationBulletMessage: 'Aller à la diapositive {{index}}',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if(dataSlideAuto === '1'){
            config.autoplay = {
                delay: dataSlideSpeed,
                disableOnInteraction: false,
            }
        }

        if(nbSlides > 1) {
            let swiperHome = new Swiper('.home-slideshow .swiper-container', config);
        }
    }

}
